<template>
  <!--
    Carrusel de dossiers (2026-10-30, estil botiga Shopify): desplaçament natiu amb encaix per targeta (al mòbil el dit
    llisca amb inèrcia i es veu un tros de la següent), fletxes i arrossegar amb el ratolí a l'escriptori, barra de
    progrés. Abans era un v-slide-group: al mòbil arrossegava a salts i les targetes no tenien la mateixa alçada.
  -->
  <div v-if="suggestedBooks && suggestedBooks.length > 0" class="ps font-rubik" :class="{'ps--compact': !bookPage}">
    <alerta-literatura
      :literaturaAlert.sync="literaturaAlert"
      :literaturaAlertMsg="literaturaAlertMsg"
      :books="allBooks"
      @addToCart="addToCart"
    ></alerta-literatura>

    <div class="ps-viewport">
      <button v-show="canPrev" type="button" class="ps-arrow ps-arrow--prev" aria-label="Anteriors" @click="page(-1)">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="mdiChevronLeft"/></svg>
      </button>

      <ul ref="track" class="ps-track" :class="{'ps-track--dragging': dragging}"
          @scroll.passive="onScroll" @pointerdown="dragStart" @click.capture="swallowClickAfterDrag">
        <li v-for="item in suggestedBooks" :key="'item-' + item.book_id" class="ps-item">
          <article class="ps-card" :class="{'ps-card--featured': isFeatured(item)}">
            <div class="ps-media" :class="{'ps-media--3d': mockups3d}" @click="openBook(item)">
              <img :src="mockups3d ? mockup3dUrl(item) : coverUrl(item)" :alt="title(item)" loading="lazy" draggable="false"
                   @error="e => { if (!e.target.dataset.fallback) { e.target.dataset.fallback = 1; e.target.src = coverUrl(item) } }">
              <span v-if="isFeatured(item) && item.kind !== 'pack'" class="ps-badge">La teva assignatura</span>
              <span v-else-if="item.oldPrice" class="ps-badge ps-badge--sale">−{{ discount(item) }}%</span>
            </div>

            <div class="ps-info">
              <h3 class="ps-title" @click="openBook(item)">{{ title(item) }}</h3>
              <div class="ps-price">
                <span v-if="item.offerPrices && item.offerPrices.offer" class="ps-now">
                  <span v-if="item.offerPrices.normal">{{ item.offerPrices.offer }} × </span>{{ money(item.price) }}
                </span>
                <span v-else class="ps-now" :class="{'ps-now--sale': item.oldPrice}">{{ money(item.price) }}</span>
                <s v-if="item.oldPrice" class="ps-was">{{ money(item.oldPrice) }}</s>
              </div>
            </div>

            <button v-if="inCart(item)" type="button" class="ps-btn ps-btn--added" @click="goToCheckout(item)">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="mdiCheck"/></svg>
              {{ locked === item.book_id ? 'Afegit' : inCart(item) === 'in_pack' ? 'Inclòs al pack' : 'Acabar la comanda' }}
            </button>
            <button v-else type="button" class="ps-btn" @click="addToCart(item)">
              Afegir a la cistella
            </button>
          </article>
        </li>
      </ul>

      <button v-show="canNext" type="button" class="ps-arrow ps-arrow--next" aria-label="Següents" @click="page(1)">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path :d="mdiChevronRight"/></svg>
      </button>
    </div>

    <div v-if="canPrev || canNext" class="ps-progress" aria-hidden="true">
      <span :style="{width: progress.width + '%', transform: `translateX(${progress.left}%)`}"></span>
    </div>
  </div>
</template>

<script>
import AlertaLiteratura from "../../components/AlertaLiteratura.vue";
import {addToCart, addPackToCart} from "../cart";
import {cartState, coverUrl, mockup3dUrl, uses3d, loadShopList, deApostrof} from "../../../examens/widgets/dossier/dossierShop";
import {mdiCheck, mdiChevronLeft, mdiChevronRight} from "/src/assets/mdi.json";

export default {
  name: "CheckoutSuggested",
  components: {AlertaLiteratura},
  props: {
    allBooks: Array,
    items: Array,
    bookPage: {
      default: false
    },
    fromExams: {
      default: false
    },
    // Emplaçament de l'anunci quan es mostra als exàmens (before_solution / after_solution)
    placement: {
      default: 'after_solution'
    },
    // Als exàmens (2026-10-30): el dossier de l'assignatura de la pàgina i el seu pack van primer. Abans la llista
    // era per vendes i 66 de 76 afegits des de l'1/9 eren d'una altra assignatura (des de Química, Filosofia...)
    featuredBookId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      url: process.env.VUE_APP_AXIOS_URI,
      literaturaAlert: false,
      literaturaAlertMsg: "",
      // Just després d'afegir, el botó (que passa a portar al checkout) no respon: evita el doble clic
      locked: null,
      mdiCheck, mdiChevronLeft, mdiChevronRight,
      canPrev: false,
      canNext: false,
      progress: {width: 100, left: 0},
      dragging: false
    }
  },
  created() {
    // cartState necessita la botiga carregada per saber si el quadern ja és dins d'un pack de la cistella
    loadShopList().catch(() => null);
  },
  mounted() {
    this.observeTrack();
  },
  updated() {
    this.observeTrack();
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.onScroll);
    this.dragEnd();
  },
  computed: {
    // Experiment mockup_style
    mockups3d() {
      return uses3d(this);
    },
    suggestedBooks() {
      if (this.allBooks && this.allBooks.length > 0) {
        const data = this.allBooks

        let books = []
        data.forEach(d => books = books.concat(d.subjects));

        // Sort by the branch id of the actual book and then the popularity of sold units
        let result = []

        data.forEach(d => result = result.concat(...d.subjects))
        result.sort((a, b) => (a.sold_units > b.sold_units ? -1 : 1))
        const interested_branches = this.items.map(i => i.branch_id);
        result.sort((a, b) => (interested_branches.includes(a.branch_id) ? -1 : 1))

        const books_ids = this.items.map(i => parseInt(i.book_id));
        result = result.filter(b => !books_ids.includes(parseInt(b.book_id)) && this.$route.params.book_id != b.book_id);

        const featured = this.featuredBookId && result.find(b => b.book_id === this.featuredBookId);
        if (featured) {
          const pack = data.flatMap(d => d.apunts || []).find(b => b.kind === 'pack' && b.examBookId === featured.book_id);
          result = [featured, ...(pack ? [pack] : []), ...result.filter(b => b !== featured)];
        }
        return result;
      }
      return []
    },
  },
  methods: {

    title(item) {
      const name = item.new_subject_name || item.subject_name;
      return item.kind === 'pack' ? `Pack exàmens + apunts ${deApostrof(name)}` : name;
    },
    isFeatured(item) {
      return !!this.featuredBookId && (item.book_id === this.featuredBookId || item.examBookId === this.featuredBookId);
    },
    money(value) {
      return Number(value).toFixed(2).replace('.', ',') + ' €';
    },
    discount(item) {
      return Math.round((1 - item.price / item.oldPrice) * 100);
    },

    // ---- Carrusel ----
    // Fletxes i barra de progrés al dia quan apareix la llista o canvia l'amplada
    observeTrack() {
      const t = this.$refs.track;
      if (!t || this.observedTrack === t) return;
      this.observedTrack = t;
      if (window.ResizeObserver) {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.onScroll());
        this.resizeObserver.observe(t);
      } else {
        window.addEventListener('resize', this.onScroll, {passive: true});
      }
      this.$nextTick(this.onScroll);
    },
    onScroll() {
      const t = this.$refs.track;
      if (!t) return;
      const max = t.scrollWidth - t.clientWidth;
      this.canPrev = t.scrollLeft > 4;
      this.canNext = t.scrollLeft < max - 4;
      const width = Math.min(100, t.clientWidth / t.scrollWidth * 100);
      this.progress = {width, left: max > 0 ? t.scrollLeft / max * (100 / width * 100 - 100) : 0};
    },
    // Una pàgina sencera (les targetes que es veuen), com les fletxes de les botigues
    page(dir) {
      const t = this.$refs.track;
      const item = t && t.querySelector('.ps-item');
      if (!item) return;
      const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 0);
      const perPage = Math.max(1, Math.floor((t.clientWidth + 1) / step));
      t.scrollBy({left: dir * perPage * step, behavior: 'smooth'});
    },
    // Arrossegar amb el ratolí (al mòbil ja ho fa el navegador, amb inèrcia)
    dragStart(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      const t = this.$refs.track;
      this.drag = {x: e.clientX, left: t.scrollLeft, moved: 0};
      window.addEventListener('pointermove', this.dragMove);
      window.addEventListener('pointerup', this.dragEnd);
    },
    dragMove(e) {
      if (!this.drag) return;
      const dx = e.clientX - this.drag.x;
      this.drag.moved = Math.max(this.drag.moved, Math.abs(dx));
      if (this.drag.moved > 5) {
        this.dragging = true;
        this.$refs.track.scrollLeft = this.drag.left - dx;
      }
    },
    dragEnd() {
      window.removeEventListener('pointermove', this.dragMove);
      window.removeEventListener('pointerup', this.dragEnd);
      const moved = this.drag && this.drag.moved > 5;
      this.drag = moved ? {moved: this.drag.moved} : null;
      if (this.dragging) {
        this.dragging = false;
        // Torna a encaixar a la targeta més propera
        const t = this.$refs.track;
        const item = t && t.querySelector('.ps-item');
        if (item) {
          const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(t).columnGap || 0);
          t.scrollTo({left: Math.round(t.scrollLeft / step) * step, behavior: 'smooth'});
        }
      }
    },
    // Si s'ha arrossegat, el clic de deixar anar no obre el llibre ni afegeix
    swallowClickAfterDrag(e) {
      if (this.drag && this.drag.moved > 5) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.drag = null;
    },
    openBook(item) {
      if (this.fromExams)
        this.$funnel.adClick(this.placement, {book_id: item.book_id, subject_id: item.subject_id});

      this.$router.push({path: '/dossiers-selectivitat/book/' + item.book_id})
    },
    coverUrl,
    mockup3dUrl,
    // Als exàmens: 'added', 'in_pack' (hi ha el pack que l'inclou) o null
    inCart(book) {
      return cartState(this, book);
    },
    goToCheckout(book) {
      if (this.locked === book.book_id) return;
      if (this.fromExams) this.$funnel.adClick(this.placement, {book_id: book.book_id, subject_id: book.subject_id, meta: {target: 'checkout'}});
      this.$router.push({path: '/checkout'});
    },
    async addToCart(book) {

      // Als exàmens només afegeix (abans també portava a la fitxa del llibre i marxaven: 58 de 113 tornaven a
      // l'examen en menys d'un minut); el segon clic porta al checkout, com els altres anuncis
      if (this.fromExams) {
        this.$funnel.adClick(this.placement, {book_id: book.book_id, subject_id: book.subject_id, meta: {target: 'add_to_cart', featured: book.book_id === this.featuredBookId || book.examBookId === this.featuredBookId}});
      }
      this.locked = book.book_id;
      setTimeout(() => (this.locked = null), 1200);

      this.$funnel.track('add_to_cart', {
        placement: this.fromExams ? this.placement : 'suggested',
        book_id: book.book_id,
        subject_id: book.subject_id
      });

      const book_id = book.book_id;
      if (book.kind === 'pack') addPackToCart(this, book);
      else addToCart(this, book_id);

      // Alert LITERATURA
      if (book_id === 29) {
        this.literaturaAlert = true;
        this.literaturaAlertMsg = "CASTELLANA"
      } else if (book_id === 30) {
        this.literaturaAlert = true;
        this.literaturaAlertMsg = "CATALANA"
      }

      this.$emit('addItem');


    },
  }

}
</script>

<style scoped>
.ps {
  --ps-gap: 14px;
  --ps-pad: 24px;
  --ps-per-view: 4;
  --ps-ink: rgb(36, 44, 68);
  --ps-muted: #6b7590;
  --ps-accent: #256EFF;
  position: relative;
  padding: 8px 0 16px;
}

.ps-viewport {
  position: relative;
}

.ps-track {
  display: flex;
  gap: var(--ps-gap);
  margin: 0;
  padding: 4px var(--ps-pad) 8px;
  list-style: none;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: var(--ps-pad);
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  cursor: grab;
}

.ps-track::-webkit-scrollbar {
  display: none;
}

.ps-track--dragging {
  cursor: grabbing;
  scroll-snap-type: none;
  user-select: none;
}

.ps-track--dragging .ps-card {
  pointer-events: none;
}

.ps-item {
  flex: 0 0 calc((100% - 2 * var(--ps-pad) - (var(--ps-per-view) - 1) * var(--ps-gap)) / var(--ps-per-view));
  min-width: 0;
  scroll-snap-align: start;
  display: flex;
}

.ps-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #e8ecf4;
  overflow: hidden;
  transition: border-color .2s ease, box-shadow .2s ease;
}

.ps-card--featured {
  border-color: #c9d8ff;
}

.ps-media {
  position: relative;
  aspect-ratio: 1 / 1;
  background: #f5f6f9;
  cursor: pointer;
  overflow: hidden;
}

.ps-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform .35s ease;
}

/* Mockups 3D: PNG transparent amb la seva ombra, sobre blanc */
.ps-media--3d {
  background: #fff;
}

.ps-media--3d img {
  object-fit: contain;
  padding: 2%;
}

.ps-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--ps-accent);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .01em;
  white-space: nowrap;
}

.ps-badge--sale {
  background: #E5484D;
}

.ps-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px 0;
}

.ps-title {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3;
  color: var(--ps-ink);
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ps-price {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: auto;
  padding-top: 2px;
}

.ps-now {
  font-size: 15px;
  font-weight: 600;
  color: var(--ps-ink);
}

.ps-now--sale {
  color: #D93036;
}

.ps-was {
  font-size: 13px;
  color: var(--ps-muted);
}

.ps-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 12px 14px 14px;
  padding: 0 8px;
  height: 40px;
  border-radius: 10px;
  border: 1.5px solid var(--ps-ink);
  background: #fff;
  color: var(--ps-ink);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background .15s ease, color .15s ease, border-color .15s ease;
}

.ps-btn svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

.ps-btn--added {
  border-color: #1B8F5D;
  background: #1B8F5D;
  color: #fff;
}

.ps-btn:focus-visible,
.ps-arrow:focus-visible {
  outline: 2px solid var(--ps-accent);
  outline-offset: 2px;
}

.ps-arrow {
  position: absolute;
  top: calc(50% - 40px);
  z-index: 2;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e3e8f2;
  background: #fff;
  box-shadow: 0 4px 14px rgba(28, 46, 92, .12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease;
}

.ps-arrow svg {
  width: 22px;
  height: 22px;
  fill: var(--ps-ink);
}

.ps-arrow--prev {
  left: 6px;
}

.ps-arrow--next {
  right: 6px;
}

.ps-progress {
  position: relative;
  height: 3px;
  margin: 6px var(--ps-pad) 0;
  border-radius: 999px;
  background: #e8ecf4;
  overflow: hidden;
}

.ps-progress span {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--ps-ink);
  transition: transform .1s linear, width .2s ease;
}

/* Només amb ratolí: hover i fletxes; amb el dit es llisca */
@media (hover: hover) and (pointer: fine) {
  .ps-card:hover {
    border-color: #d5ddef;
    box-shadow: 0 8px 24px rgba(28, 46, 92, .08);
  }

  .ps-card:hover .ps-media img {
    transform: scale(1.04);
  }

  .ps-btn:not(.ps-btn--added):hover {
    background: var(--ps-ink);
    color: #fff;
  }

  .ps-btn--added:hover {
    background: #167a4f;
  }

  .ps-arrow:hover {
    transform: scale(1.06);
    box-shadow: 0 6px 18px rgba(28, 46, 92, .18);
  }
}

@media (hover: none), (pointer: coarse) {
  .ps-arrow {
    display: none !important;
  }

  .ps-track {
    cursor: auto;
  }
}

@media (max-width: 1263px) {
  .ps {
    --ps-per-view: 3.3;
  }
}

/* Mòbil: dues targetes i un tros de la tercera, perquè es vegi que es pot lliscar */
@media (max-width: 599px) {
  .ps {
    --ps-per-view: 2.15;
    --ps-pad: 16px;
    --ps-gap: 10px;
  }

  .ps-info {
    padding: 10px 10px 0;
  }

  .ps-title {
    font-size: 14px;
  }

  .ps-btn {
    margin: 10px;
    height: 38px;
    font-size: 12.5px;
    letter-spacing: -.01em;
  }

  .ps-badge {
    top: 8px;
    left: 8px;
    padding: 2px 7px;
    font-size: 10px;
  }
}

/* Fora de les fitxes (cistella): targetes més petites */
.ps--compact {
  --ps-per-view: 2.4;
}

.ps--compact .ps-title {
  font-size: 13.5px;
}

.ps--compact .ps-btn {
  height: 34px;
  font-size: 12.5px;
}
</style>
